var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "date",
    title: "Accounting Date",
    description: "Date in YYYYMMDD format, stored as a string.",
    type: "field",
    use: {
        namespace: "ua.select.date"
    },
    fields: {
        min: {
            title: "Minimum Date",
            type: "string"
        },
        max: {
            title: "Maximum Date",
            type: "string"
        }
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ min: "20250101", max: "20251231" }, "20250611");
            }
        },
        tooEarly: {
            throw: "fields.date.outOfRange",
            run: function () {
                return validate({ min: "20250101" }, "20200101");
            }
        },
        tooLate: {
            throw: "fields.date.outOfRange",
            run: function () {
                return validate({ max: "20251231" }, "20260101");
            }
        },
        invalidFormat: {
            throw: "fields.date.invalid",
            run: function () {
                return validate({}, "2025-06-11");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Date",
            description: "Must be a valid accounting date in YYYYMMDD format.",
            template: "Date '${value}' is invalid."
        },
        outOfRange: {
            title: "Date Out of Range",
            description: "The date is outside the allowed range.",
            template: "Date '${value}' is not between ${min} and ${max}"
        }
    }
});

function validate(spec, value) {
    if (typeof value !== "string" || !/^[0-9]{8}$/.test(value)) {
        _.errors.invalid.throw({ value: value });
    }

    if (spec.min && value < spec.min) {
        _.errors.outOfRange.throw({ value: value, min: spec.min, max: spec.max });
    }

    if (spec.max && value > spec.max) {
        _.errors.outOfRange.throw({ value: value, min: spec.min, max: spec.max });
    }
}
module.exports.validate = validate;
